import { render } from "./ModalReject.vue?vue&type=template&id=48c4b754"
import script from "./ModalReject.vue?vue&type=script&lang=js"
export * from "./ModalReject.vue?vue&type=script&lang=js"

import "./ModalReject.vue?vue&type=style&index=0&id=48c4b754&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__